import { render, staticRenderFns } from "./UsuariosView.vue?vue&type=template&id=2a3b934e&"
import script from "./UsuariosView.vue?vue&type=script&lang=ts&"
export * from "./UsuariosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports